import { BaseEntityResource } from '@/modules/core/app/resources/BaseEntityResource';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { ChatGptSummary } from '@/modules/ta/chatgptsummaries/models/ChatGptSummary';
import { ReportExecutiveSummaryPageModel } from '@/modules/ta/chatgptsummaries/models/ReportExecutiveSummaryPageModel';

export class ChatGptSummariesResource extends BaseEntityResource {
  constructor() {
    super(`${RouteGroup.AISUMMARIES}`, ChatGptSummary);
  }

  /**
   * @param formData
   * @returns {Promise<AxiosResponse<any>>}
   */
  async generateChatGptSummary(formData = {}) {
    return this.apiHelper.post(`${RouteGroup.AISUMMARIES}/generatesummary`, formData);
  }

  /**
   * @param formData
   * @returns {Promise<AxiosResponse<*>>}
   */
  async generateDalleSummary(formData = {}) {
    return this.apiHelper.post(`${RouteGroup.AISUMMARIES}/generatedallesummary`, formData);
  }

  /**
   * @param id
   * @param formData
   * @returns {Promise<AxiosResponse<any>>}
   */
  async addExecutiveSummaryItem(formData = {}) {
    return this.apiHelper.post(`${RouteGroup.AISUMMARIES}/executivesummary/item`, formData);
  }

  /**
   * @param id
   * @param formData
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getLatestResponse(id, formData) {
    return this.apiHelper.post(`${RouteGroup.AISUMMARIES}/summary/latest/${id}`, formData);
  }

  /**
   * @param id
   * @param formData
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getLatestDalleResponse(id, formData) {
    return this.apiHelper.post(`${RouteGroup.AISUMMARIES}/summary/latest/dalle/${id}`, formData);
  }

  /**
   * @param summaryId
   * @returns {Promise<AxiosResponse<any>>}
   */
  async exportWidgetData(summaryId = {}) {
    await this.download(`export/${summaryId}/widgetdata`);
  }

  /**
   * @param summaryId
   * @param formData
   * @returns {Promise<void>}
   */
  async deleteItem(summaryId, formData = {}) {
    await this.apiHelper.post(`${RouteGroup.AISUMMARIES}/summary/delete/${summaryId}`, formData);
  }

  /**
   * Fetches and returns executive summary pages of the passed reportId
   *
   * @param reportId
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async getReportExecutiveSummaryPages(reportId) {
    return this.getData(ReportExecutiveSummaryPageModel, `${reportId}/reportpages`);
  }
}

export default new ChatGptSummariesResource();
